import React, { useState } from 'react'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import NavigateNextRoundedIcon from '@material-ui/icons/NavigateNextRounded';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';

const SavedCardPreview = ({ 
  setCardDetails,
  paymentMethod, 
  connectedStripeId 
}) => {
  const API_URL = 'https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com';
  const [displayDeleteOption, setDisplayDeleteOption] = useState(false);
 
  const deleteCard = async () => {
    const { data, error } = await axios.post(`${API_URL}/remove-payment-method`,{
      paymentMethodId: paymentMethod.id,
      connectedStripeId
    });
    
    setCardDetails(null);
    setDisplayDeleteOption(false)
  }

  return (
    <>
      <Card>
        <CardContent>
          <Typography  display='inline' color="textPrimary" gutterBottom>
          <CreditCardIcon />
          
          {paymentMethod.card?.brand} &bull;&bull;&bull; {paymentMethod.card?.last4} | {paymentMethod.card?.exp_month}/{paymentMethod.card?.exp_year}
          {!displayDeleteOption && 
            <IconButton onClick={() => setDisplayDeleteOption(true)} variant="text" size="small">
              <NavigateNextRoundedIcon />
            </IconButton>
          }
          </Typography>
        </CardContent>
      </Card>
      
      {displayDeleteOption &&
        <>
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            onClick={deleteCard}
          >
            Remove card
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="text"
            onClick={() => setDisplayDeleteOption(false)}
          >
            Go back
          </Button>
        </>
      }
    </>
  )
}

export default SavedCardPreview